// src/pages/customer/ForgotPassword.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useAuth } from "../../context/AuthContext";
import Spinner from "../../components/common/Spinner";
import toast from "react-hot-toast";
import { FiMail, FiCheckCircle } from "react-icons/fi";

export default function ForgotPassword() {
  const { resetPassword } = useAuth();
  const [loading, setLoading] = useState(false);
  const [sent,    setSent]    = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async ({ email }) => {
    setLoading(true);
    try {
      await resetPassword(email);
      setSent(true);
      toast.success("Reset email sent!");
    } catch {
      toast.error("Failed to send reset email. Check the address.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-200px)] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="card p-7">
          {sent ? (
            <div className="text-center py-4">
              <FiCheckCircle className="w-12 h-12 text-primary-600 mx-auto mb-4" />
              <h3 className="font-semibold text-gray-900 mb-2">Email sent!</h3>
              <p className="text-sm text-gray-500 mb-6">Check your inbox and follow the instructions to reset your password.</p>
              <Link to="/login" className="btn-primary inline-block">Back to Login</Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                <h1 className="font-display text-2xl font-bold text-gray-900">Reset Password</h1>
          <p className="text-gray-500">We'll send a reset link to your email</p>
              <div>
                <label className="label">Email address</label>
                <div className="relative">
                  <FiMail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                  <input
                    {...register("email", { required: "Email is required", pattern: { value: /^\S+@\S+$/, message: "Invalid email" } })}
                    type="email" placeholder="you@example.com"
                    className={`input pl-9 ${errors.email ? "border-red-400" : ""}`}
                  />
                </div>
                {errors.email && <p className="text-xs text-red-500 mt-1">{errors.email.message}</p>}
              </div>
              <button type="submit" disabled={loading} className="btn-primary w-full flex items-center justify-center gap-2">
                {loading ? <><Spinner size="sm" /> Sending...</> : "Send Reset Link"}
              </button>
              <p className="text-center text-sm text-gray-600">
                Remember it? <Link to="/login" className="text-primary-600 font-medium hover:underline">Sign in</Link>
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
